declare global {
  interface Window {
    serviceHub?: any
    embedded_svc?: any
    culture?: any
  }
}

type Languages = "nl-NL" | "nl-BE" | "fr-BE" | "fr-FR"

interface IConfig {
  lang: Languages
  service: Record<Languages, string>
  text: {
    chat: Record<Languages, string>
    feedback: Record<Languages, string>
    service: Record<Languages, string>
    title: Record<Languages, string>
  },
  position?: "left" | "right"
  offset?: {
    x: string
    y: string
  },
  customButtons?: Record<Languages, { url: string, text: string }>[]
}

const hub = (config: IConfig) => {
  let fab: HTMLElement = document.querySelector("#fab")
  if (fab)
    return

  config.position ??= "right"
  config.offset ??= { x: "0px", y: "0px" }

  let fabBg: HTMLElement
  let fabMenu: HTMLElement
  let surveyBtn: HTMLElement
  let chat: boolean
  let chatInterval: any
  let closeTimer: any

  const insertFabHTML = () =>
    fab.innerHTML = `<svg id="fab_icon_closed" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
<path d="M6 17.9H7V17.0826L6.19893 16.92L6 17.9ZM6.82925 22.2744L6.17075 21.5218L6.17075 21.5218L6.82925 22.2744ZM11.7143 18V17H11.3386L11.0558 17.2474L11.7143 18ZM3 7C3 4.79086 4.79086 3 7 3V1C3.68629 1 1 3.68629 1 7H3ZM3 13V7H1V13H3ZM6.19893 16.92C4.37356 16.5494 3 14.934 3 13H1C1 15.9039 3.06196 18.324 5.80107 18.88L6.19893 16.92ZM7 21.8981V17.9H5V21.8981H7ZM6.17075 21.5218C6.49404 21.2389 7 21.4685 7 21.8981H5C5 23.1869 6.51788 23.8756 7.48776 23.027L6.17075 21.5218ZM11.0558 17.2474L6.17075 21.5218L7.48776 23.027L12.3728 18.7526L11.0558 17.2474ZM17 17H11.7143V19H17V17ZM21 13C21 15.2091 19.2091 17 17 17V19C20.3137 19 23 16.3137 23 13H21ZM21 7V13H23V7H21ZM17 3C19.2091 3 21 4.79086 21 7H23C23 3.68629 20.3137 1 17 1V3ZM7 3H17V1H7V3Z" fill="#ffffff"/>
</svg>
      <svg id="fab_icon_open" xmlns="http://www.w3.org/2000/svg" width="18.179" height="18.179" viewBox="0 0 18.179 18.179">
      <g id="Group_5" data-name="Group 5" transform="translate(1.414 1.414)">
      <line id="Line_1" data-name="Line 1" x2="15.351" y2="15.351" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
      <line id="Line_2" data-name="Line 2" x1="15.351" y2="15.351" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
      </g>
      </svg>`

  const insertFabMenuHTML = () => {
    const customButtons = Array.isArray(config.customButtons)
      ? config.customButtons
        .filter(x => x[config.lang])
        .map(x => `<li class="custom" data-url="${x[config.lang].url}">${x[config.lang].text}</li>`)
        .join("")
      : ""
    const html = `<span>${config.text.title[config.lang]}</span>
         <ul>
         <li id="fab_chat" style="display: none;">${config.text.chat[config.lang]}</li>
         <li id="fab_service">${config.text.service[config.lang]}</li>
         <li id="fab_feedback" style="display: none;">${config.text.feedback[config.lang]}</li>
         ${customButtons}
         </ul>`

    fabMenu.innerHTML = html

    fabMenu.querySelector("#fab_feedback").addEventListener("click", openSurvey)
    fabMenu.querySelector("#fab_chat").addEventListener("click", openChat)
    fabMenu.querySelector("#fab_service").addEventListener("click", openService)

    Array.from(fabMenu.querySelectorAll("li.custom"))
      .forEach((x: any) => x.addEventListener("click", e => {
        window.open(e.target.getAttribute("data-url"), e.target.innerText).focus()
        close()
      }))
  }

  const createElements = () => {
    fab = document.createElement("div")
    fabBg = document.createElement("div")
    fabMenu = document.createElement("div")
    fab.setAttribute("id", "fab")
    fabBg.setAttribute("id", "fab_bg")
    fabMenu.setAttribute("id", "fab_menu")
    document.body.appendChild(fab)
    document.body.appendChild(fabBg)
    document.body.appendChild(fabMenu)

    insertFabHTML()
    insertFabMenuHTML()

    fab.addEventListener("click", open)
    fabBg.addEventListener("click", close)
    fabMenu.addEventListener("mouseenter", function () { clearTimeout(closeTimer) })
    fabMenu.addEventListener("touchstart", function () { clearTimeout(closeTimer) })
  }

  let initStyles = () => {
    {
      const style = document.createElement("style")
      style.textContent = `
        #fab { position: fixed; z-index: 998; ${config.position}: 24px; bottom: 24px; width: 48px; height: 48px; transform: translate(${config.offset.x}, ${config.offset.y}); background-color: #c700b9; border-radius: 50%; box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 15px -5px; cursor: pointer; overflow: hidden; transition: background-color .2s .1s ease-in-out, width .2s .1s, height .2s .1s, transform .2s .1s; display: inline-flex; align-items: center; justify-content: center; }
        #fab:hover #fab_icon_closed {scale: 1.1;}
        #fab:hover {background-color: color-mix(in oklab, #c700b9 80%, transparent);}
        #fab.-open:hover {background-color: color-mix(in oklab, #c700b9 80%, transparent);}
        #fab_bg { position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 900; opacity: 0; pointer-events: none; transition: opacity .2s; }
        #fab_menu { position: fixed; ${config.position}: 24px; bottom: 70px; width: 200px; height: auto; background-color: white; z-index: 999; padding: 16px; border-radius: 8px; font-size: 1.5rem; opacity: 0; transform: translate(${config.offset.x}, ${config.offset.y}) translateY(20px); pointer-events: none; transition: opacity .2s, transform .2s; box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 12px 0px; }
        #fab_menu > span {font-family:"HemaDemibold";}
        #fab #fab_icon_closed { width: 24px; height: 24px; transition: opacity .2s .1s, scale .2s ease-in-out; }
        #fab #fab_icon_open { width: 30px; height: 14px; margin: 8px 0 0 0; position: absolute; left: 0; top: 0; opacity:0 ; transition: opacity .2s; }
        #fab_menu ul { display: flex; flex-direction: column; margin-top: 5px; }
        #fab_menu ul li {border-bottom: 1px solid #DFDFDF; font-family: "HemaBook"; padding: 6px 0; list-style: none; cursor: pointer; border-radius: 2px; transition: background-color .2s ease-in-out; }
        #fab_menu ul li:hover {background-color: #f5f5f5; }
        #fab.-open { width: 30px; height: 30px; background-color: #c700b9; transition: background-color .2s, width .2s, height .2s, transform .2s; }
        #fab.-open #fab_icon_closed { opacity: 0; transition: opacity .2s; }
        #fab.-open #fab_icon_open { opacity: 1; transition: opacity .2s .1s; }
        #fab_bg.-open { opacity: 1; pointer-events: auto; }
        #fab_menu.-open { opacity: 1; transform: translate(${config.offset.x}, ${config.offset.y}) translateY(0px); pointer-events: auto; transition: opacity .2s .1s, transform .2s .1s; }
        #fab.-hidden { transform: translateY(32px) scale(0); }
        `
      document.head.appendChild(style)
    }

    {
      const style = document.createElement("style")
      style.textContent = `
        .embeddedServiceSidebar { font-family: 'HemaBook' !important; } 
        #esw-channelmenu_header > h2, #esw-channelmenu_header > p, .embeddedServiceSidebar .sidebarHeader > h2 { color: white !important; }
        .embeddedServiceSidebarButton .label { top: 0; }
      `
      document.head.appendChild(style)
    }
  }

  const open = () => {
    if (fab.classList.contains("-open"))
      close()
    else {
      show()
      fab.classList.add("-open")
      fabBg.classList.add("-open")
      fabMenu.classList.add("-open")
    }
  }

  const close = () => {
    fab.classList.remove("-open")
    fabBg.classList.remove("-open")
    fabMenu.classList.remove("-open")
  }

  const hide = () => {
    close()
    fab.classList.add("-hidden")
  }

  const show = () => {
    fab.classList.remove("-hidden")
  }

  const initSurvey = () => {
    if (surveyBtn)
      return

    const survey: HTMLElement = document.querySelector("#surveyContent")
    if (!survey)
      return

    Object.assign(survey.style, { display: "none" })
    surveyBtn = survey.querySelector("button")

    const fabSurvey: HTMLElement = fabMenu.querySelector("#fab_feedback")
    if (fabSurvey)
      Object.assign(fabSurvey.style, { display: "" })
  }

  const initChat = () => {
    if (chat)
      return

    chat = "embedded_svc" in window && "menu" in window.embedded_svc && "hideButtonAndMenu" in window.embedded_svc.menu
    if (!chat)
      return

    if (new URLSearchParams(document.location.search).get("chat"))
      openChat()
    else {
      const btnInterval = setInterval(() => {
        if (document.querySelector("#esw-channelmenu.hideAnimation"))
          clearInterval(btnInterval)
        else
          window.embedded_svc.menu.hideButtonAndMenu()
      }, 1000)
    }


    if (chatInterval)
      clearInterval(chatInterval)
    chatInterval = setInterval(() => {
      const checks = [
        !!document.querySelector("#esw-channelmenu.hideAnimation"),
        !document.querySelector(".embeddedServiceSidebar.sidebarMaximized"),
        !document.querySelector(".embeddedServiceSidebar.sidebarMinimized"),
        !document.querySelector(".notification.showMinimizedNotification")
      ]
      if (checks.every(x => x === true)) {
        closeChat()

      }
    }, 1000)

    const fabChat: HTMLElement = fabMenu.querySelector("#fab_chat")
    if (fabChat)
      Object.assign(fabChat.style, { display: "" })
  }

  const openSurvey = () => {
    if (!surveyBtn)
      initSurvey()
    surveyBtn.click()
    close()
  }

  const openChat = () => {
    const btn = document.querySelector<HTMLButtonElement>('#esw-fab');
    if (btn)
      btn.style.visibility = ""
    window.embedded_svc.menu.showButtonAndMenu()
    window.embedded_svc.menu.openChannelMenu()
    hide()
  }
  const closeChat = () => {
    const btn = document.querySelector<HTMLButtonElement>('#esw-fab');
    btn.style.visibility = "hidden"
    window.embedded_svc.menu.hideButtonAndMenu()
    show()
  }

  const openService = () => {
    window.open(config.service[config.lang], "service").focus()
    close()
  }

  const watch = () => {
    let attempts = 0
    const interval = setInterval(() => {
      attempts++
      initSurvey()
      initChat()
      if (attempts > 100 || (chat && surveyBtn))
        clearInterval(interval)
    }, 100)
  }

  createElements()
  initChat()
  initSurvey()
  watch()
  initStyles()

  return {
    open,
    close,
    openSurvey,
    openChat,
    openService,
  }
}

const config: IConfig = {
  lang: window.culture || document.body.classList[0] as Languages || "nl-NL",
  service: {
    "nl-NL": "/klantenservice/", // https://foto.hema.nl
    "nl-BE": "/klantenservice/", // https://foto.hema.be
    "fr-BE": "/fr/service-clientele/", // https://foto.hema.be
    "fr-FR": "/fr-fr/service-clientele/", // https://photo.hema.com
  },
  text: {
    chat: {
      "nl-NL": "chat met ons",
      "nl-BE": "chat met ons",
      "fr-BE": "Chattez avec nous",
      "fr-FR": "Chattez avec nous"
    },
    feedback: {
      "nl-NL": "geef ons feedback",
      "nl-BE": "geef ons feedback",
      "fr-BE": "Foire aux questions",
      "fr-FR": "Foire aux questions"
    },
    service: {
      "nl-NL": "klantenservice",
      "nl-BE": "klantenservice",
      "fr-BE": "Service clientèle",
      "fr-FR": "Service clientèle"
    },
    title: {
      "nl-NL": "kunnen we je helpen?",
      "nl-BE": "kunnen we je helpen?",
      "fr-BE": "Pouvons-nous vous aider ?",
      "fr-FR": "Pouvons-nous vous aider ?"
    }
  },
  position: "right",
  offset: {
    x: "0px",
    y: "0px"
  },
}

export const init = () => {
  if (window.serviceHub === false || window.serviceHub === "false")
    return

  window.serviceHub = hub(config)
}